import { Paper, PaperProps, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

interface Props extends PaperProps {
	onClickCustomValue: () => void;
	term?: string;
}

export default function SearchNotFound({ onClickCustomValue, term = "", ...other }: Props) {
	const { translate } = useLocales();

	if (term) {
		return (
			<Paper {...other}>
				<Typography align='center' gutterBottom variant='subtitle1'>
					{translate("Sin coincidencias")}
				</Typography>
				<Typography align='center' variant='body2'>
					{translate(
						`No se han encontrado resultados para ${term}. Comprueba que no hay errores o intenta otras palabras.`
					)}
				</Typography>
			</Paper>
		);
	}

	return (
		<Typography variant='body2'>{translate("Por favor introduzca las palabras clave")}</Typography>
	);
}
